// import React from 'react'
// import HomePage from './Pages/Homepage/Homepage'

// const App = () => {
//   return (
//     <div>
//       <HomePage/>
//     </div>
//   )
// }

// export default App

// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import PageRoutes from './Pages/Routes/PageRoutes';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <PageRoutes />
      </Router>
    </ThemeProvider>
  );
}

export default App;